import React, { useMemo, useState, useEffect, useRef } from 'react';
import TextField from '@mui/material/TextField';

const CurrencyField = ({ value, onChange, fieldSelect = false }) => {
  const fieldRef = useRef(null);
  const [price, setPrice] = useState('');

  const handleInputChange = (event) => {
    const inputValue = event.target.value.replace(/[^0-9]/g, '');
    const formattedValue = (Number(inputValue) / 100).toFixed(2).replace('.', ',');
    setPrice(formattedValue);
    onChange(inputValue);
  };

  const handleFocus = () => {
    if (fieldRef.current) {
      fieldRef.current.select();
    }
  };

  const formattedValue = useMemo(() => (Number(value) / 100).toFixed(2).replace('.', ','), [value]);

  useEffect(() => {
    setPrice(formattedValue);
  }, [formattedValue]);

  return (
    <TextField
      name="price"
      label="Preço"
      variant="outlined"
      value={price}
      onChange={handleInputChange}
      onFocus={handleFocus}
      fullWidth
      step="0.50"
      inputRef={fieldRef}
      sx={{
        '& .MuiInputBase-input': {
          fontSize: '14px',
        },
      }}
    />
  );
};

export default CurrencyField;

